"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listProgrammingHistoryApiResponseSchema = exports.programmingHistoryItemSchema = exports.listOfficeProgrammingsApiResponseSchema = exports.weekProgrammingItemSchema = exports.programWeekApiResponseSchema = exports.programWeekApiPayloadSchema = exports.officeAssistantSummarySchema = exports.weekProgrammingAssignmentSchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
exports.weekProgrammingAssignmentSchema = zod_1.z.object({
    assistantId: zod_1.z.string().uuid(),
    templateWeek: enums_1.templateWeekSchema,
});
exports.officeAssistantSummarySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    firstname: zod_1.z.string(),
    lastname: zod_1.z.string(),
    initials: zod_1.z.string(),
});
// — Program a week
exports.programWeekApiPayloadSchema = zod_1.z.object({
    officeId: zod_1.z.string().uuid(),
    isoWeek: zod_1.z.string().regex(/^\d{4}-W\d{2}$/),
    assignments: zod_1.z.array(exports.weekProgrammingAssignmentSchema).min(1),
});
exports.programWeekApiResponseSchema = zod_1.z.object({ success: zod_1.z.boolean() });
// — List forward programmings (current week + horizon)
exports.weekProgrammingItemSchema = zod_1.z.object({
    isoWeek: zod_1.z.string(),
    weekNumber: zod_1.z.number().int(),
    monday: zod_1.z.string(), // YYYY-MM-DD
    sunday: zod_1.z.string(),
    isLocked: zod_1.z.boolean(),
    isCurrent: zod_1.z.boolean(),
    assignments: zod_1.z.array(exports.weekProgrammingAssignmentSchema),
});
exports.listOfficeProgrammingsApiResponseSchema = zod_1.z.object({
    page: zod_1.z.number().int(),
    totalPages: zod_1.z.number().int(),
    startingWeekNumber: zod_1.z.number().int(),
    weeks: zod_1.z.array(exports.weekProgrammingItemSchema),
    officeAssistants: zod_1.z.array(exports.officeAssistantSummarySchema),
});
// — History
exports.programmingHistoryItemSchema = zod_1.z.object({
    isoWeek: zod_1.z.string(),
    weekNumber: zod_1.z.number().int(),
    monday: zod_1.z.string(),
    sunday: zod_1.z.string(),
    assignments: zod_1.z.array(exports.weekProgrammingAssignmentSchema),
});
exports.listProgrammingHistoryApiResponseSchema = zod_1.z.object({
    page: zod_1.z.number().int(),
    perPage: zod_1.z.number().int(),
    total: zod_1.z.number().int(),
    totalWeeks: zod_1.z.number().int(),
    items: zod_1.z.array(exports.programmingHistoryItemSchema),
    officeAssistants: zod_1.z.array(exports.officeAssistantSummarySchema),
});
